import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = "+41779938989";

export const WhatsAppButton = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent("Guten Tag, ich interessiere mich für Ihre Sicherheitsdienstleistungen.");
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, '')}?text=${message}`, '_blank');
  };

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.3 }}
      onClick={openWhatsApp}
      className="whatsapp-float pulse-gold"
      data-testid="whatsapp-floating-btn"
      aria-label="WhatsApp kontaktieren"
    >
      <MessageCircle size={28} className="text-[#0B0F19]" />
    </motion.button>
  );
};
